import { DoubleDown, SharedIconButton } from "@components";

import styled from "styled-components";

export const DividerLine = () => {
  return (
    <StyledLine>
      <div className="line" />
      <div className="btn">
        <SharedIconButton type="text" icon={<DoubleDown />} />
      </div>
    </StyledLine>
  );
};
const StyledLine = styled.section`
  display: flex;
  align-items: center;
  max-width: 960px;
  .line {
    flex: 14;
    height: 2px;
    background: ${(p) => p.theme.colors.main};
  }
  .btn {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
`;
